import React from "react";
export default function FilesPickerRow(props) {
  const onPick = () => {
    if (props.onFilePick) {
      props.onFilePick(props);
    }
  };

  const fileSizeFormat = (size) => {
    let kbSize = Math.round(size / 1024);
    return <span>{kbSize} Кб.</span>;
  };

  const date = props.date ? new Date(props.date).toLocaleDateString() : "";
  return (
    <div
      className="py-4 px-2 cursor-pointer border-bottom text-dark list-item no-select"
      onDoubleClick={onPick}
    >
      <div className="d-flex justify-content-start align-items-top">
        <div className="mr-2">
          <i className="fa fa-file-o"></i>
        </div>
        <div>
          {props.name}
          {props.text && <div className="small text-dark-75">{props.text}</div>}
          <div className="small text-dark-50">
            {fileSizeFormat(props.size)} {props.userlabel} {date}
          </div>
        </div>
      </div>
    </div>
  );
}
